<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-close="close" vm-size="medium" @vm-accept="close" :vm-buttons-hidden="true" :vm-accept-text="$t('strings.sent_individual')" :vm-is-valid="true" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalVisible" :vm-title='title')
    vm-col.card(vm-sm=12)
      vm-table(:data="details")
        template(slot="thead")
          vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('sending_receptions.' + column) }}
        template(slot-scope="{data}")
          vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
            vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
              slot(v-if="column == 'product'") {{data[indextr]['product']['name']}}
              slot(v-if="column == 'sending_detail'") {{data[indextr]['quantity_to_send']}}
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('SendingReceptionInformation')
export default {
  name: 'ModalSendingReceptions',
  props: {
    sending_id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    columns: [
      'product',
      'sending_detail'
    ]
  }),
  validations: {},
  computed: {
    ...mapGetters([
      'details',
      'isModalVisible'
    ]),
    title () {
      return this.$t('strings.sendings')
    }
  },
  watch: {
    isModalVisible (flag) {
      if (flag) {
        this.loadSendigRecetions({ sending_information: this.sending_id })
      }
    }
  },
  methods: {
    ...mapActions([
      'setModalVisible',
      'loadSendigRecetions'
    ]),
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>
